/* FizzBitz theme.js - header menu, cart drawer, product form, quantity */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = window.FizzBitz && window.FizzBitz.moneyFormat ? window.FizzBitz.moneyFormat : '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
    const nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    let v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart drawer ---------- */
  const drawer = document.getElementById('cart-drawer');
  const countEls = document.querySelectorAll('[data-cart-count]');

  function setCount(n) {
    countEls.forEach((el) => { el.textContent = n; el.dataset.count = n; });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    const body = drawer.querySelector('[data-drawer-lines]');
    const total = drawer.querySelector('[data-drawer-total]');
    const foot = drawer.querySelector('[data-drawer-foot]');
    const empty = drawer.querySelector('[data-drawer-empty]');
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '';
      empty.hidden = false;
      foot.hidden = true;
      return;
    }
    empty.hidden = true;
    foot.hidden = false;
    total.textContent = money(cart.total_price);
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2')}" alt="" width="72" height="72" loading="lazy">` : '<div></div>'}
        <div>
          <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__meta">${item.variant_title}</div>` : ''}
          <div class="product__row" style="margin-top:8px">
            <div class="qty">
              <button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>
              <input type="number" min="0" value="${item.quantity}" data-line-qty aria-label="Quantity">
              <button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>
            </div>
            <span class="cart-line__price">${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-line__remove" data-line-remove>Remove</button>
        </div>
      </div>`).join('');
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function changeLine(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await r.json();
    renderDrawer(cart);
    return cart;
  }

  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-qty]');
      if (!input) return;
      const line = input.closest('[data-line-key]');
      changeLine(line.dataset.lineKey, parseInt(input.value, 10));
    });
    drawer.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      const line = rm.closest('[data-line-key]');
      changeLine(line.dataset.lineKey, 0);
    });
    document.querySelectorAll('[data-cart-open]').forEach((el) => {
      el.addEventListener('click', async (e) => {
        if (document.body.dataset.template === 'cart') return;
        e.preventDefault();
        renderDrawer(await fetchCart());
        openDrawer();
      });
    });
  }

  /* ---------- Product forms (AJAX add) ---------- */
  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    form.addEventListener('submit', async (e) => {
      if (!drawer) return; // fall back to normal submit
      e.preventDefault();
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      if (err) err.textContent = '';
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        renderDrawer(await fetchCart());
        openDrawer();
        btn.textContent = 'Added';
        setTimeout(() => { btn.textContent = label; }, 1500);
      } catch (ex) {
        if (err) err.textContent = ex.message;
        btn.textContent = label;
      } finally {
        btn.disabled = false;
      }
    });
  });

  /* ---------- Variant selects + gallery ---------- */
  document.querySelectorAll('[data-variant-select]').forEach((sel) => {
    const form = sel.closest('form');
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    sel.addEventListener('change', () => {
      const opt = sel.selectedOptions[0];
      idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      const btn = form.querySelector('[type="submit"]');
      const avail = opt.dataset.available !== 'false';
      btn.disabled = !avail;
      btn.textContent = avail ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
    });
  });

  document.querySelectorAll('[data-thumb]').forEach((t) => {
    t.addEventListener('click', () => {
      const main = document.querySelector('[data-main-image]');
      if (!main) return;
      main.src = t.dataset.src;
      main.alt = t.dataset.alt || '';
      document.querySelectorAll('[data-thumb]').forEach((o) => o.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- Cart page quantity updates ---------- */
  document.querySelectorAll('[data-cart-page] [data-line-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      const line = input.closest('[data-line-index]');
      const f = document.createElement('form');
      f.method = 'post'; f.action = '/cart/change';
      f.innerHTML = `<input name="line" value="${line.dataset.lineIndex}"><input name="quantity" value="${input.value}">`;
      document.body.appendChild(f); f.submit();
    });
  });
})();
